<template>
    <div>
        <popup-write-link v-for="component in optionLayouts" :key="`memberComp${component}`" :writeLayout="component" :popupData="popupData" :setData="setData"></popup-write-link>
    </div>
</template>

<script>
    import VuxAlert from '@/mixins/vux-alert';
    import popupUtil from "@/components/popup/popupUtil";
    import PopupWriteLink from "@/components/popup/PopupWriteLink";
    import popupValidator from "@/mixins/validators/popupValidator";
    import EventBus from "@/utils/event-bus";
    import util from "@/mixins/util";
    import elFileMixins from "@/mixins/elFileMixins";

    export default {
        name: 'PopupWriteComponent',
        components: {
            PopupWriteLink
        },
        mixins: [ VuxAlert, popupUtil, popupValidator ,elFileMixins],
        props: {
            popupType: {
                type: String,
                default: '',
            },
            popupKey: {
                default: null,
            },
        },
        data() {
            return{
                optionLayouts: [],
                parsingData: {},
                createApiParamSet: {},
                detailApiParamSet: {},
                subFunc: '',
                directUrl: '',
                resultAlertTxt: '',

                popupData: {},
            }
        },
        mounted() {
        },
        watch: {

        },
        created() {
            this.initConfig();
            EventBus.$on('writePopup', this.writePopup);
        },
        beforeDestroy() {
            EventBus.$off('writePopup');
        },
        methods: {
            initConfig() {
                let popupConfig = this.returnPopupConfig(this.popupType)
                this.createApiParamSet = popupConfig.createApiParamSet;
                this.detailApiParamSet = popupConfig.detailApiParamSet;
                this.subFunc = popupConfig.subFunc;
                this.directUrl = popupConfig.directUrl;
                this.resultAlertTxt = popupConfig.resultAlertTxt;
                this.parsingData = popupConfig.parsingData;
                this.directType = popupConfig.directType;
                this.fileType = popupConfig.fileType;
                if(this.popupKey != null) {
                    this.getPopup();
                }else{
                    this.initTemplate();
                }
            },
            initTemplate() {
                let popupConfig = this.returnPopupConfig(this.popupType)
                this.optionLayouts = popupConfig.optionLayouts;
            },
            setData(key, value) {
                this[key] = value;
            },
            getPopup() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.id = this.popupKey;
                this.no = this.popupKey;
                try {
                    this.$api.$popup.getPopup(params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1) {
                            this.createAlert({
                                title: '알림',
                                content: '팝업을 불러올 수 없습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                        }
                        this.popupData = res.List[0];
                        this.initTemplate();
                    });
                }catch (e) {
                    console.log(e);
                }
            },
            writePopup() {
                let dataKeys = Object.keys(this.parsingData);
                if (this.l_display === 1 || this.l_display === 2 ) {
                    dataKeys.push('link')
                }
                if(!util.isEmpty(this.fileType)) {
                    dataKeys.push('files')
                }

                this.$validate(dataKeys).then((success) => {
                    if(!success) {
                        this.errorAlert('모두 입력해주세요.');
                        return false;
                    }
                    let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                    let dataKeys = Object.keys(this.parsingData);
                    dataKeys.forEach(dataKey => {
                        params[this.parsingData[dataKey]] = this[dataKey];
                    });
                    if (this.l_display === 1 || this.l_display === 2) {
                        params.e_url = this.link;
                    }
                    if(!util.isEmpty(this.popupKey)){
                        params.e_idx = this.popupKey
                    }
                    try {
                        this.$api.$popup[this.subFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type != 1) {
                                this.errorAlert('저장에 실패하였습니다.');
                                return false;
                            }
                            if(!util.isEmpty(this.deleteFiles)) {
                                this.removeFiles(this.deleteFiles)
                            }
                            if(!util.isEmpty(this.fileType) && !util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0){
                                this.uploadFiles(this.files, this.fileType, res.List).then(success => {
                                    this.afterFunc(res.List);
                                });
                            }else{
                                this.afterFunc(res.List);
                            }
                        })
                    }catch (e) {
                        console.log(e);
                    }
                })
            },
            afterFunc(key) {
                if(this.popupKey != 0) {
                    EventBus.$emit('popupListUpdateAfterFunc', this.keyName, Number(this.popupKey));
                }else{
                    EventBus.$emit('popupListAddAfterFunc');
                }
                let detailKey = key;
                this.createAlert({
                    title: '',
                    content: this.resultAlertTxt,
                    btnText: '확인',
                    hide: () => {
                        if(this.directType === 'back') {
                            this.$router.back();
                            return false;
                        }
                        if(this.directUrl === '') {
                            this.optionLayouts = [];
                            this.deleteFiles = [];
                            this.getPopup();
                            return false;
                        }
                        let url = this.directUrl;
                        if(this.directType === 'detail') {
                            url = url+detailKey;
                        }
                        this.$router.push(url);
                    }
                })
            },
        }
    }
</script>
